module.exports = __webpack_public_path__ + "static/media/customPlus.0170d5d6.svg";